import { isBooleanTrue, isNumberGreaterThanZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import PrescriptionAddOnDetails from "./PrescriptionAddOnDetails";

// add ons are for things like boxes/packaging, inserts, etc that are added to the order
// but not part of the products being sold and cant be ordered/purchased on their own
class OrderGroupAddOn {
    name = null; // the name of the product/variant to display on the order/orderGroup
    sku = null; // the product sku for the addon
    productId = null;
    variantId = null;
    quantity = 0;

    refId = null; // refId would be like the reference prescription Id in the supplier's system if this has to be created in their system as a prescription
    status = null; // pharmacy status for this add-on item (e.g., CREATED, SUBMITTED, FILLED, SHIPPED)
    requiresPrescription = false;
    prescriptionDetails = null;

    constructor(obj) {
        if (isObjectNotEmpty(obj)) {
            if (isStringNotEmpty(obj.name)) { this.name = obj.name; }
            if (isStringNotEmpty(obj.sku)) { this.sku = obj.sku; }
            if (isStringNotEmpty(obj.productId)) { this.productId = obj.productId; }
            if (isStringNotEmpty(obj.variantId)) { this.variantId = obj.variantId; }
            if (isNumberGreaterThanZero(obj.quantity)) { this.quantity = obj.quantity; }

            if (isStringNotEmpty(obj.refId)) { this.refId = obj.refId; }
            if (isStringNotEmpty(obj.status)) { this.status = obj.status; }
            if (isBooleanTrue(obj.requiresPrescription)) { this.requiresPrescription = true; }
            if (isObjectNotEmpty(obj.prescriptionDetails)) { this.prescriptionDetails = new PrescriptionAddOnDetails(obj.prescriptionDetails).toDto(); }
        }
    }

    toDto = () => {
        return {
            name: this.name,
            sku: this.sku,
            productId: this.productId,
            variantId: this.variantId,
            quantity: this.quantity,

            refId: this.refId,
            status: this.status,
            requiresPrescription: this.requiresPrescription,
            prescriptionDetails: this.prescriptionDetails
        };
    }
}

export default OrderGroupAddOn;
